<!-- `webviewer.component.html` -->
<!-- Simple DOM element for WebViewer to populate -->
<div class="page">
  <div #viewer class="viewer"></div>
</div>
